import { isAncillaryContentSubtype } from "../../../../../common/types/AncillaryContentType";
import { ContentReferenceType } from "../../../../../common/types/ContentReferenceType";
import { isMovieContentSubtype } from "../../../../../common/types/MovieContentSubtype";
import { isTvSeriesContentSubtype } from "../../../../../common/types/TvSeriesContentSubtype";
import { ContentAssociationFormState } from "../../../../common/content/types/ContentAssociationFormState";
import {
    FileRecordDetails,
    FileRecordContentDetails,
    FileRecordMovieDetails,
    FileRecordTvSeriesDetails,
    FileRecordAncillaryDetails
} from "../../../../common/file-record-details/FileRecordDetails";

export const mapToFileRecordContentAssociationFormState = (
    fileRecordDetails: FileRecordDetails
): ContentAssociationFormState => {
    const { content } = fileRecordDetails;

    if (!content) {
        return { contentType: undefined };
    }

    if (isFileRecordDetailsMovieContent(content)) {
        return {
            contentType: ContentReferenceType.Movie,
            contentId: content.movie.id,
            versionIds: content.versions.map((version) => version.id)
        };
    }

    if (isFileRecordDetailsTvSeriesContent(content)) {
        return {
            contentType: ContentReferenceType.TvSeries,
            contentId: content.tvSeries.id,
            episodeId: content.episode.id,
            seasonId: content.season.id,
            versionIds: content.versions.map((version) => version.id)
        };
    }

    if (isFileRecordDetailsAncillaryContent(content)) {
        return {
            contentType: ContentReferenceType.Ancillary,
            contentId: content.ancillary.id,
            airlineId: content.airline.id
        };
    }

    throw new Error("Unsupported content subtype");
};

const isFileRecordDetailsMovieContent = (content: FileRecordContentDetails): content is FileRecordMovieDetails => {
    return isMovieContentSubtype(content.contentSubtype);
};

const isFileRecordDetailsTvSeriesContent = (
    content: FileRecordContentDetails
): content is FileRecordTvSeriesDetails => {
    return isTvSeriesContentSubtype(content.contentSubtype);
};

const isFileRecordDetailsAncillaryContent = (
    content: FileRecordContentDetails
): content is FileRecordAncillaryDetails => {
    return isAncillaryContentSubtype(content.contentSubtype);
};
